import React, {useEffect, useState, Fragment} from 'react';
import RNUFormService from "../../../../services/RNUFormService";
import {CHECK_IMG} from "../../../../constants";
import NumberFormat from "react-number-format";
import Color from "color";


const Template1BPreemptionDemo = (props) => {

    const rnuFormService = new RNUFormService()
    const [items, setItems]= useState([])
    const fetchData = rnuFormService.getData('preemption')
    const [asSurface, setAsSurface] = useState()
    const refDocType1 = [
        {"id":1,"code": 1,"name":'DPU(s)', "labelle": 'Droit de préemption simple'},
        {"id":2,"code": 2,"name":'DPU(r)', "labelle": 'Droit de préemption renforcé'},
        {"id":3,"code": 3,"name":'DPFC', "labelle": 'Droit de préemption sur les fonds de commerces'},
        {"id":4,"code": 4,"name":'ENS', "labelle": 'Droit de préemption sur les espaces naturels sensibles'},
        {"id":5,"code": 5,"name":'ZAC', "labelle": 'Droit de préemption dans les zones d\'aménagement concerté'},
        {"id":6,"code": 6,"name":'ZAD', "labelle": 'Droit de préemption dans une zone d\'aménagement differé'},
        {"id":7,"code": 7,"name":'SAFER', "labelle": 'Les droits de préemption de la SAFER s\'appliquent en cas de vocation agricole (article L. 143-1 du code rural de la pêche maritime) et/ou en cas de parcelle enclavée au sens de l\'article 682 du code civil'},
    ]

    useEffect(()=>{
        (fetchData)?setItems(fetchData):null;
        (props.formtype === 'level2' ||  props.formtype === 'level1')?setAsSurface(true):setAsSurface(null);
    },[fetchData])

    const renderItem=(item,index, docfind, itemResult)=>{

            return (
                <tr key={index} style={{"borderBottom": "1px solid #ccc"}}>
                    <td >
                       démo
                    </td>
                    <td>
                        <span style={{"whiteSpace": "pre-warp"}} >Lorem ipsum dolor sit amet, consectetur.</span>
                    </td>
                    <td className={'text-center'} style={{verticalAlign: 'middle'}}>
                        {
                            (docfind)
                                ? 'Oui'
                                : 'Non'
                        }
                    </td>
                    {
                        (asSurface) ?
                            <Fragment>
                                <td className={'ue-col-surface'} style={{"width": "60px"}}>
                                    {(itemResult && itemResult.surface && Number(itemResult.surface) > 0)
                                        ?
                                        <span><NumberFormat value={Math.round(itemResult.surface)} displayType={'text'}
                                                            thousandSeparator={' '}/>m<sup>2</sup> </span>
                                        : null
                                    }

                                </td>
                                <td className={'ue-col-percent'} style={{"width": "140px", "paddingLeft": "20px"}}>
                                    {
                                        (itemResult && itemResult.pourcentage && Number(itemResult.pourcentage) > 0)
                                            ? <span>{Math.round(itemResult.pourcentage * 10) / 10} %</span>
                                            : null
                                    }
                                </td>
                            </Fragment>
                            :null
                    }
                </tr>
            )
    };

    return (
        <div className="ue-section">
            <div className="text-left text-underline">
                <h3>{(props.formtype !== 'ru') ?'ARTICLE 4 - ':null}Droit de préemtion</h3>
            </div>
            <p>Le bien est soumis au périmètre ci dessous :</p>

            <table className={"ue-form-table-row"} style={{"border":"none"}}>
                <thead >
                    <tr className={"ue-table-row-header"}>
                        <th style={{"width": "50px"}}>Cat.</th>
                        <th>Description</th>
                        <th style={{"width": "30px"}}> </th>
                        {
                            (asSurface) ?
                                <th style={{"width": "130px"}} className={"text-center"} colSpan={2}>Surface</th>
                                :null
                        }
                    </tr>
                </thead>
                <tbody>
                {(items)?
                    refDocType1.map((item, index) => {
                        let result = _.findIndex(items, (o)=>{return o.id_layer === item.code })
                        let docFind = (result>=0);
                        return (renderItem(item, index, docFind, (result>=0)?items[result]:null))
                    })
                    :null
                }
                </tbody>
            </table>
            <br/>
            <p style={{"fontSize":"0.6rem", "fontStyle":"italic", "color": "#969696"}}>
                Avant  toute  mutation  du  terrain  ou  des  bâtiments,  le  propriétaire  devra  faire  une  déclaration  d'intention  d'aliéner  auprès  du
                bénéficiaire du droit de préemption. Elle comportera l'indication du prix et les conditions de la vente projetée. SANCTION : nullité
                de la vente en cas d'absence de déclaration.
            </p>

        </div>
    );
};

export default Template1BPreemptionDemo;
